// ========================== SYSTEM ADMINISTRATION =======================
const systemAdministration = {
  name: "SYSTEM ADMINISTRATION",
  icon: "settings",
  children: [
    { name: "Company Holidays", iconText: "SI", path: "/holiday" },
    { name: "System Settings", iconText: "SI", path: "/system-settings" },
    { name: "Plan Management", iconText: "SI", path: "/plan" },
  ],
};

// ========================== LEAVE MANAGEMENT =============================
const leaveManagement = {
  name: "LEAVE MANAGEMENT",
  icon: "calendar_month",
  children: [
    { name: "Leave Applications", iconText: "SI", path: "/leave/tracker" },
    { name: "Leave Balances", iconText: "SI", path: "/leave/balances" },
    { name: "Leave Reconciliation", iconText: "SI", path: "/leave/reconciliation" },
    { name: "Leave Setup", iconText: "SI", path: "/leave/setup" },
  ],
};

// ========================== WORKFLOW & APPROVALS ==========================
const workflowApprovals = {
  name: "WORKFORCE & APPROVALS",
  icon: "assignment",
  children: [
    {
      name: "Activity Tracking",
      iconText: "SI",
      path: "/employees/activity-tracking",
    },
    {
      name: "App Management",
      iconText: "SI",
      path: "/employees/app-management",
    },
    { name: "Revision Requests", iconText: "SI", path: "/employee/requests" },
    { name: "Approvals", iconText: "SI", path: "/approvals" },
    
  ],
};

// ---------------------------EMPLOYEE ATTENDANCE----------------------------
const workflowEmployeeAttendace = {
  name: "ATTENDANCE MANAGEMENT",
  icon: "assignment",
  children: [
    { name: "Attendance", iconText: "SI", path: "/admin_attendance_list" },
    { name: "Leave Tracker", iconText: "SI", path: "/leaves" },
  ],
};

// ========================== ADMIN DASHBOARD BUILDER =======================
export const getNavigationAsPerRole = (role, config = {}) => {
  // ✅ Dynamically build EMPLOYEE MANAGEMENT section
  const workforceEmployeeManagementAttendance = {
    name: "EMPLOYEE MANAGEMENT",
    icon: "fact_check",
    children: [
      { name: "Employees", iconText: "SI", path: "/employees/list" },
     
      ...(config?.isEmployeeManagement
        ? [
            // {
            //   name: "Organization Structure",
            //   iconText: "SI",
            //   path: "/employees/structure",
            // },
          ]
        : []),
    ],
  };

  // ✅ Combine all ADMIN menus
  const adminDashboard = [
    { name: "DASHBOARD", path: "/dashboard", icon: "dashboard" },
    workforceEmployeeManagementAttendance,
    workflowEmployeeAttendace,
    leaveManagement,
    workflowApprovals,
    { name: "VISITORS", icon: "summarize", path: "/visitor/list" },
    {
      name: "TIMESHEET",
      icon: "access_time",
      children: [
        { name: "Timesheet Approvals", iconText: "SI", path: "/timesheet-approval" },
        { name: "Projects", iconText: "SI", path: "/projects" },
      ],
    },
    systemAdministration,
    { name: "REPORTS", icon: "summarize", path: "/reports" },
  ];

  // ✅ EMPLOYEE dashboard menus
  const userDashboard = [
    { name: "DASHBOARD", path: "/employee-dashboard", icon: "dashboard" },
    { name: "ATTENDANCE", path: "/attendance", icon: "schedule" },
    { name: "LEAVES", path: "/employee-leave", icon: "beach_access" },
    { name: "MY ACTIVITY", path: "/my-activity", icon: "trending_up" },
    { name: "MY TIMESHEET", path: "/my-timesheet", icon: "timer" },
    { name: "Company Holidays", path: "/holiday-calendar", icon: "event" },
    // { name: "My Profile", path: "/employees/profile", icon: "person" },
          ...(config?.isEmployeeManagement
        ? [
            { name: "My Profile", path: "/employees/profile", icon: "person" },
          ]
        : []),
  ];

  // ✅ SYSTEM ROLE dashboard
  if (role === "system") {
    return [
      { name: "DASHBOARD", path: "/system-dashboard", icon: "dashboard" },
      { name: "COMPANY", path: "/admin/company", icon: "group" },
    ];
  }

  // ✅ ADMIN / HR / SUPER-ADMIN vs normal employee
  return ["SUPER-ADMIN", "ADMIN", "HR"].includes(role)
    ? adminDashboard
    : userDashboard;
};
